import _ from 'lodash';

import { LoanApplicationTabName } from 'constants/loanApplication';

export const FINANCIAL_INFO_TAB_NAME = LoanApplicationTabName.FINANCIAL_INFO;
export const FINANCIAL_INFO_TAB_ROUTE = _.kebabCase(FINANCIAL_INFO_TAB_NAME);
